import { Component, h } from 'preact'
import { IdeaStatus } from '../../control-components/ideation-status/Types'
import IdeationColumn from './pipeline/IdeationColumn'
import { Idea } from './Types'
import axios from 'axios'

interface Props {
  title: string
  column1: number
  column2: number
  column3: number
  maxHeight: number
  currentUserId: number
  isGuest: boolean
  onChange: (state: {title: string}) => void
}

interface State {
  ideaStatusList: IdeaStatus[]
  ideasFirstCol: {
    topics: Idea[]
    totalTopicCount: number
  }
  ideasSecondCol: {
    topics: Idea[]
    totalTopicCount: number
  }
  ideasThirdCol: {
    topics: Idea[]
    totalTopicCount: number
  }
}

class Pipeline extends Component<Props, State> {
  constructor (props: Props) {
    super(props)

    this.state = {
      ideaStatusList: [],
      ideasFirstCol: {
        topics: [],
        totalTopicCount: 0
      },
      ideasSecondCol: {
        topics: [],
        totalTopicCount: 0
      },
      ideasThirdCol: {
        topics: [],
        totalTopicCount: 0
      }
    }
  }

  getIdeationStatusTitle (ideaStatusId: number) {
    const items: IdeaStatus[] = this.state.ideaStatusList.filter((status: IdeaStatus) => status.id === ideaStatusId.toString())

    if (!items.length) return ''

    return items[0].name
  }

  async getIdeasByIdeationStatus (ideaStatusName: string) {
    const filters = { ideationStatus: [ideaStatusName] }

    const res = await axios.get('ideas/topics', {
      params: {
        filters,
        sort: {
          votes: 'desc'
        }
      }
    })

    if (res.data) {
      return res.data
    }
    return {
      ideas: [],
      totalTopicCount: 0
    }
  }

  async componentDidMount () {
    const { data } = await axios.get('/community/api/ideas/ideaStatuses')
    if (!data.result.length) {
      return
    }

    this.setState({ ideaStatusList: data.result })

    const titleFirstColumn = this.getIdeationStatusTitle(this.props.column1)
    const ideasFirst = await this.getIdeasByIdeationStatus(titleFirstColumn)

    const titleSecondColumn = this.getIdeationStatusTitle(this.props.column2)
    const ideasSec = await this.getIdeasByIdeationStatus(titleSecondColumn)

    const titleThirdColumn = this.getIdeationStatusTitle(this.props.column3)
    const ideasThird = await this.getIdeasByIdeationStatus(titleThirdColumn)

    this.setState({
      ideasFirstCol: ideasFirst,
      ideasSecondCol: ideasSec,
      ideasThirdCol: ideasThird
    })
  }

  render (
    { title, column1, column2, column3, maxHeight, currentUserId, isGuest }: Props,
    { ideasFirstCol, ideasSecondCol, ideasThirdCol }: State
  ) {
    return (
      <section class='full-width Template-brand-featured pipeline__widget'>
        <div class='sitewidth'>
          <div class='col'>
            {
              title ? <h3 className='widget__heading'>{title}</h3> : null
            }
            <div className='pipeline-col-list' style={{ 'max-height': maxHeight }}>
              <IdeationColumn
                ideaStatusTitle={this.getIdeationStatusTitle(column1)}
                ideaList={ideasFirstCol.topics}
                totalTopicCount={ideasFirstCol.totalTopicCount}
                maxHeight={maxHeight}
                currentUserId={currentUserId}
                isGuest={isGuest}
              />
              <IdeationColumn
                ideaStatusTitle={this.getIdeationStatusTitle(column2)}
                ideaList={ideasSecondCol.topics}
                totalTopicCount={ideasSecondCol.totalTopicCount}
                maxHeight={maxHeight}
                currentUserId={currentUserId}
                isGuest={isGuest}
              />
              <IdeationColumn
                ideaStatusTitle={this.getIdeationStatusTitle(column3)}
                ideaList={ideasThirdCol.topics}
                totalTopicCount={ideasThirdCol.totalTopicCount}
                maxHeight={maxHeight}
                currentUserId={currentUserId}
                isGuest={isGuest}
              />
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default Pipeline
